import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-white px-4 sm:px-6 py-6 text-black">
      <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-6">
        {/* Left: Logo + Tagline (tagline kept below logo for all sizes) */}
        <div className="flex flex-col items-center gap-4 w-full md:w-auto">
          <img
            src={logo}
            alt="BuildTravel Logo"
            className="w-40 sm:w-48 md:w-[234.34px] h-auto flex-shrink-0"
          />
          <p className="font-sans text-superbase text-center">
            Build your memory with us.
          </p>
        </div>

        {/* Right: Contact Info + Links */}
        <div className="flex flex-col items-center md:items-end text-center md:text-right gap-4 w-full md:w-auto">
          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 sm:gap-6 text-sm">
            <span>026315315</span>
            <span>contact@buildmytravel.ae</span>
            <span>Hamdan Street, Abu Dhabi</span>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center md:justify-end gap-3 font-sans font-semibold text-[20px] md:text-[27px]">
            <button
              className="text-left hover:underline"
              onClick={() => alert("About Us clicked")}
            >
              About Us
            </button>
            <button
              className="text-left hover:underline"
              onClick={() => alert("Privacy Policy clicked")}
            >
              Privacy Policy
            </button>
            <button
              className="text-left hover:underline"
              onClick={() => alert("Account clicked")}
            >
              Account
            </button>
            <button
              className="text-left hover:underline"
              onClick={() => alert("Cookie Policy clicked")}
            >
              Cookie Policy
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
